import React, { Component } from "react";
import {
  Typography,
  Paper,
  Divider,
  Select,
  Checkbox,
  Grid,
} from "@material-ui/core";

export default class Features extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: this.props.state.filter,
    };
  }

  render() {
    return (
      <React.Fragment>
        <Paper style={{ padding: 5, width: "100%" }}>
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="stretch"
          >
            <Grid item>
              <h2>Categorïen</h2>
              <Divider />
            </Grid>
            <Grid item container justify="space-between" alignItems="center">
              <Grid item xs={9}>
                <Typography component={"span"}>Aantal per pagina:</Typography>
              </Grid>
              <Grid item xs={3}>
                <Select
                  value={this.state.filter.display}
                  onChange={(e) => {
                    this.state.filter.display = e.target.value;
                    this.props.Filter_Update(this.state.filter);
                  }}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Select>
              </Grid>
            </Grid>
            <Divider />
            <Grid item container justify="space-between" alignItems="center">
              <Grid item xs={9}>
                <Typography>Modellen:</Typography>
              </Grid>
              <Grid item xs={3}>
                <Checkbox
                  checked={this.state.filter.modellen}
                  onChange={(e) => {
                    this.state.filter.modellen = e.target.checked;
                    this.props.Filter_Update(this.state.filter);
                  }}
                ></Checkbox>
              </Grid>
            </Grid>
            <Divider />
            <Grid item container justify="space-between" alignItems="center">
              <Grid item xs={9}>
                <Typography>Modellen DINH wel gekocht</Typography>
              </Grid>
              <Grid item xs={3}>
                <Checkbox
                  checked={this.state.filter.modellen_DINH_WG}
                  onChange={(e) => {
                    this.state.filter.modellen_DINH_WG = e.target.checked;
                    this.props.Filter_Update(this.state.filter);
                  }}
                ></Checkbox>
              </Grid>
            </Grid>
            <Grid item container justify="space-between" alignItems="center">
              <Grid item xs={9}>
                {" "}
                <Typography>Modellen DINH niet gekocht</Typography>
              </Grid>
              <Grid item xs={3}>
                <Checkbox
                  checked={this.state.filter.modellen_DINH_NG}
                  onChange={(e) => {
                    this.state.filter.modellen_DINH_NG = e.target.checked;
                    this.props.Filter_Update(this.state.filter);
                  }}
                ></Checkbox>
              </Grid>
            </Grid>
            <Divider />
            <Grid item container justify="space-between" alignItems="center">
              <Grid item xs={9}>
                {" "}
                <Typography>Alles Könner 406</Typography>
              </Grid>
              <Grid item xs={3}>
                <Checkbox
                  checked={this.state.filter.AllesKönner}
                  onChange={(e) => {
                    this.state.filter.AllesKönner = e.target.checked;
                    this.props.Filter_Update(this.state.filter);
                  }}
                ></Checkbox>
              </Grid>
            </Grid>
            <Divider />
            <Grid item container justify="space-between" alignItems="center">
              <Grid item xs={9}>
                <Typography>Pins </Typography>
              </Grid>
              <Grid item xs={3}>
                <Checkbox
                  checked={this.state.filter.pins}
                  onChange={(e) => {
                    this.state.filter.pins = e.target.checked;
                    this.props.Filter_Update(this.state.filter);
                  }}
                ></Checkbox>
              </Grid>
            </Grid>
            <Divider />
            <Grid item container justify="space-between" alignItems="center">
              <Grid item xs={9}>
                <Typography>Video's </Typography>
              </Grid>
              <Grid item xs={3}>
                <Checkbox
                  checked={this.state.filter.videos}
                  onChange={(e) => {
                    this.state.filter.videos = e.target.checked;
                    this.props.Filter_Update(this.state.filter);
                  }}
                ></Checkbox>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}
